module.exports = __webpack_public_path__ + "assets/img/mecha-btn-2eb0edb2.png";